var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative h-full w-full bg-white p-[25px]"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }